import "./header.css";
import { useNavigate, useLocation } from "react-router-dom";
import { IoIosArrowForward, IoIosHelpCircleOutline } from "react-icons/io";
import { Popover } from "antd";
import { useSelector } from "react-redux";

const Header = ({ title, backHandler }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const hints = useSelector((state) => state.TechAppReducer.hints);

  return (
    <div className="mv_header">
      {backHandler ? (
        <IoIosArrowForward
          style={{ fontSize: "24px", paddingBottom: "5px" }}
          onClick={() => {
            navigate("/techapp/tickets");
            backHandler();
          }}
        />
      ) : null}
      <span onClick={backHandler} style={{ marginLeft: "auto" }}>
        {title}
      </span>
      {/* help popover */}
      {location.pathname !== "/techapp/create-ticket" ? (
        <>
          {hints.map((hint, index) => {
            if (
              location.pathname === "/techapp/survey" &&
              hint.section === "survey_page" &&
              hint.type === "text" &&
              hint.body.length > 0
            ) {
              return (
                <Popover
                  key={index}
                  trigger={"click"}
                  placement="bottom"
                  title={<div style={{ textAlign: "right" }}>راهنما</div>}
                  content={
                    <div style={{ textAlign: "right", maxWidth: 270 }}>
                      {hint.body}
                    </div>
                  }
                >
                  <div style={{ marginRight: "auto" }} className="help_button">
                    <IoIosHelpCircleOutline
                      style={{ color: "#1e5279", fontSize: 22 }}
                    />
                  </div>
                </Popover>
              );
            } else if (
              location.pathname === "/techapp/survey" &&
              hint.section === "survey_page" &&
              hint.type === "link" &&
              hint.body.length > 0
            ) {
              return (
                <div
                  key={index}
                  style={{ marginRight: "auto" }}
                  onClick={() => window.open(hint.body, "_blank")}
                  className="help_button"
                >
                  <IoIosHelpCircleOutline
                    style={{ color: "#1e5279", fontSize: 22 }}
                  />
                </div>
              );
            } else if (
              location.pathname === "/techapp/tickets" &&
              hint.section === "tickets_page" &&
              hint.type === "text" &&
              hint.body.length > 0
            ) {
              return (
                <Popover
                  key={index}
                  trigger={"click"}
                  placement="bottom"
                  title={<div style={{ textAlign: "right" }}>راهنما</div>}
                  content={
                    <div style={{ textAlign: "right", maxWidth: 270 }}>
                      {hint.body}
                    </div>
                  }
                >
                  <div style={{ marginRight: "auto" }} className="help_button">
                    <IoIosHelpCircleOutline
                      style={{ color: "#1e5279", fontSize: 22 }}
                    />
                  </div>
                </Popover>
              );
            } else if (
              location.pathname === "/techapp/tickets" &&
              hint.section === "tickets_page" &&
              hint.type === "link" &&
              hint.body.length > 0
            ) {
              return (
                <div
                  key={index}
                  style={{ marginRight: "auto" }}
                  onClick={() => window.open(hint.body, "_blank")}
                  className="help_button"
                >
                  <IoIosHelpCircleOutline
                    style={{ color: "#1e5279", fontSize: 22 }}
                  />
                </div>
              );
            } else if (
              location.pathname === "/techapp/transactions" &&
              hint.section === "transactions_page" &&
              hint.type === "text" &&
              hint.body.length > 0
            ) {
              return (
                <Popover
                  key={index}
                  trigger={"click"}
                  placement="bottom"
                  title={<div style={{ textAlign: "right" }}>راهنما</div>}
                  content={
                    <div style={{ textAlign: "right", maxWidth: 270 }}>
                      {hint.body}
                    </div>
                  }
                >
                  <div style={{ marginRight: "auto" }} className="help_button">
                    <IoIosHelpCircleOutline
                      style={{ color: "#1e5279", fontSize: 22 }}
                    />
                  </div>
                </Popover>
              );
            } else if (
              location.pathname === "/techapp/stats" &&
              hint.section === "profile_my_performance" &&
              hint.type === "link" &&
              hint.body.length > 0
            ) {
              return (
                <div
                  key={index}
                  style={{ marginRight: "auto" }}
                  onClick={() => window.open(hint.body, "_blank")}
                  className="help_button"
                >
                  <IoIosHelpCircleOutline
                    style={{ color: "#1e5279", fontSize: 22 }}
                  />
                </div>
              );
            } else if (
              location.pathname === "/techapp/stats" &&
              hint.section === "profile_my_performance" &&
              hint.type === "text" &&
              hint.body.length > 0
            ) {
              return (
                <Popover
                  key={index}
                  trigger={"click"}
                  placement="bottom"
                  title={<div style={{ textAlign: "right" }}>راهنما</div>}
                  content={
                    <div style={{ textAlign: "right", maxWidth: 270 }}>
                      {hint.body}
                    </div>
                  }
                >
                  <div style={{ marginRight: "auto" }} className="help_button">
                    <IoIosHelpCircleOutline
                      style={{ color: "#1e5279", fontSize: 22 }}
                    />
                  </div>
                </Popover>
              );
            } else if (
              location.pathname === "/techapp/stats" &&
              hint.section === "profile_my_performance" &&
              hint.type === "link" &&
              hint.body.length > 0
            ) {
              return (
                <div
                  key={index}
                  style={{ marginRight: "auto" }}
                  onClick={() => window.open(hint.body, "_blank")}
                  className="help_button"
                >
                  <IoIosHelpCircleOutline
                    style={{ color: "#1e5279", fontSize: 22 }}
                  />
                </div>
              );
            }

            return '';
          })}
        </>
      ) : null}
    </div>
  );
};
export default Header;
